'use strict';
var __importDefault =
	(this && this.__importDefault) ||
	function (mod) {
		return mod && mod.__esModule ? mod : {default: mod};
	};
Object.defineProperty(exports, '__esModule', {value: true});
exports.productVariantFragment = exports.selectedAttributeFragment = exports.basicProductFragment = void 0;
const graphql_tag_1 = __importDefault(require('graphql-tag'));
const checkout_1 = require('./checkout');
exports.basicProductFragment = graphql_tag_1.default`
  fragment BasicProductFields on Product {
    id
    name
    leadTime
    thumbnail {
      url
      alt
    }
    thumbnail2x: thumbnail(size: 510) {
      url
    }
    merchant {
      id
      name
      storeHourStart
      storeHourEnd
      operatingDays
      storeTitle
      storeDescription
      slug
      logo {
        url
      }
      warehouses (first: 5) {
        edges {
          node {
            name
            companyName
            address {
              streetAddress1
              streetAddress2
              latitude
              longitude
              city
              phone
              email
            }
          }
        }
      }
    }
  }
`;
exports.selectedAttributeFragment = graphql_tag_1.default`
  fragment SelectedAttributeFields on SelectedAttribute {
    attribute {
      id
      name
      slug
    }
    values {
      id
      name
    }
  }
`;
exports.productVariantFragment = graphql_tag_1.default`
  ${checkout_1.checkoutPriceFragment}
  fragment ProductVariantFields on ProductVariant {
    id
    sku
    name
    quantityAvailable(countryCode: $countryCode)
    isAvailable
    images {
      id
      url
      alt
    }
    pricing {
      onSale
      priceUndiscounted {
        ...Price
      }
      price {
        ...Price
      }
    }
    attributes {
      attribute {
        id
        name
        slug
      }
      values {
        id
        name
        value: name
      }
    }
  }
`;
//# sourceMappingURL=products.js.map
